import { type AuthUser } from 'wasp/auth';
import { useRedirectHomeUnlessUserIsAdmin } from "../useRedirectHomeUnlessUserIsAdmin"
import DefaultLayout from '../layout/DefaultLayout';
import { useEffect, useState } from 'react';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';


const AdminDebugPage = ({ user }: { user: AuthUser }) => {
useRedirectHomeUnlessUserIsAdmin({user})
const [activeTab, setActiveTab] = useState('1');
const handleChange = (event: React.SyntheticEvent, newValue: string) => {
  setActiveTab(newValue);
};

const dataClassName = ""

return (
  <DefaultLayout user={user}>
    <TabContext value={activeTab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="Gengage agent options">
            <Tab label="Data" value="1" />
            <Tab label="Logs" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
         <div className='flex flex-col gap-2'>
            {Object.entries(user).map(([key, value]) => (
              <div key={key} className={dataClassName}>
                <strong>{key}:</strong> {JSON.stringify(value)}
              </div>
            ))}
         </div>
        </TabPanel>
        <TabPanel value="2">
          <div>Logs</div>
        </TabPanel>
      </TabContext>
  </DefaultLayout>
)
}

export default AdminDebugPage;